export enum TEMPLATE_IDS {
    'GOOGLE_ANALYTICS' = 'HkocEodjb7',
    'GOOGLE_MAPS' = 'S1pcEj_jZX',
    'OXOMI_CATALOGUE' = 'V-Uemi-UM',
    'OXOMI_VIDEO' = '_ARBMvoJV03dHU',
    'QUESTIONIZER' = 'W3hxsYc8w',
    'SOFTGARDEN' = 'YnyOqdIcs',
    'YOUTUBE_NO_COOKIE' = 'jNhZyJPmEwhlwm',
    'YOUTUBE_VIDEO' = 'BJz7qNsdj-7'
}
